/*eslint-disable react/no-danger*/
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

import { getChatActiveState } from 'selectors';
import './styles.scss';

const ChatWritingIndicator = (props) => {
  const { counsellorName, isVisible } = props;
  return (
    <div className="ChatWritingIndicator">
      {isVisible && <p dangerouslySetInnerHTML={{ __html: `<strong>${counsellorName}</strong> is typing` }} />}
    </div>
  );
};

ChatWritingIndicator.propTypes = {
  isVisible: PropTypes.bool,
  counsellorName: PropTypes.string
};

const mapStateToProps = state => {
  const chatActiveState = getChatActiveState(state);
  const isVisible = chatActiveState.counsellorWriting === true;
  const counsellorName = chatActiveState.counsellor && chatActiveState.counsellor.userName;

  return {
    isVisible,
    counsellorName
  };
};

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatWritingIndicator);




/** WEBPACK FOOTER **
 ** ./src/members/Main/ChatWindow/ChatWritingIndicator/index.js
 **/